module.exports = __webpack_public_path__ + "static/media/pin_empty.bf0070e1.svg";